<template>
  <div class="container flex">
    <div class="ml20 mt20" v-for="item in list">
      <div class="erweima">
        <img :src="item.url" style="width: 100%; height: 100%" alt="" />
      </div>
      <div style="width: 250px">
        <p class="center blod f18 mt20">{{ item.title }}</p>
        <p class="mt10 center f12 intro">{{item.intro}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "product",
  computed: {
    message() {
      return "The webmaster said that you can not enter this page...";
    },
  },
  data() {
    return {
      list: [
        {
          url: require("../assets/productImg/1.png"),
          title: "防火物联平台",
          intro: "智慧消防云平台是将大数据、云计算、物联网、地理信息等新一代信息管理技术高度融合的智慧化平台。平台将远程监控、无线烟感、消防给水系统监测、电气监测、可燃气体监测、电子巡更、BIM可视化、无人机等集成在一个统一的架构下，通过标准的展示界面，为客户提供集火灾防控标准化、救援指挥智能化、日常巡查规范化、智慧管理精细化为一体的综合性消防管理服务。",
        },
        {
          url: require("../assets/productImg/2.png"),
          title: "建筑工程消防验收",
          intro: "依据《重大火灾隐患判定方法 GB35181-2017》规定,根据建筑场所不同，给出不同的直接判定和综合判定条件。系统自动给出专业的判定结果，减少检查人员工作步骤。",
        },
        {
          url: require("../assets/productImg/3.png"),
          title: "消防评估",
          intro: "帮助评估人员对评估内容进行表格化、坐标化处理，在评估过程中可以通过手动输入、语音录入、图片记录来达到真正的无纸化操作。",
        },
        {
          url: require("../assets/productImg/4.png"),
          title: "重大火灾隐患自动判定系统",
          intro: "重大火灾隐患判定小程序是一款轻量级软件，简单实用，不占空间。帮助企业快速高效排查隐患，降低火灾发生风险，减少专家查隐患的人力及时间成本；辅助监管人员判定隐患等级，全面监管企业火灾隐患动态。",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.erweima {
  width: 250px;
  height: 250px;
}
.container {
  flex-wrap: wrap;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 20px;
}
.intro{
 text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  line-clamp: 5;
  -webkit-box-orient: vertical;}
</style>
